








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class SyntaxHighlighter extends Vue {
  @Prop({ required: true }) data!: any
  @Prop({ default: 4 }) indent: number
  @Prop({ default: 'text-tes-navy-blue-darker' }) keyHighlightClass: string
  @Prop({ default: 'text-tes-green' }) numberHighlightClass: string
  @Prop({ default: 'text-tes-green' }) booleanHighlightClass: string
  @Prop({ default: 'text-indigo' }) stringHighlightClass: string
  @Prop({ default: 'text-tes-purple' }) nullHighlightClass: string

  private get json() {
    return JSON.stringify(this.data, undefined, this.indent)
  }

  private get highlighted() {
    return this.syntaxHighlight(this.json)
  }

  private syntaxHighlight(json) {
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
      match => {
        let highlightClass = this.numberHighlightClass
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            highlightClass = this.keyHighlightClass
          } else {
            highlightClass = this.stringHighlightClass
          }
        } else if (/true|false/.test(match)) {
          highlightClass = this.booleanHighlightClass
        } else if (/null/.test(match)) {
          highlightClass = this.nullHighlightClass
        }
        return `<span class="${highlightClass}">${match}</span>`
      }
    )
  }
}
